<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-textarea
          v-model="timeoutRespostaSolicitanteMensagemLocale"
          dense
          outlined
          no-resize
          label="Mensagem de aviso pela falta de resposta do solicitante"
          hint="Máximo de 300 caracteres"
          validate-on-blur
          :loading="loading"
          :rules="[validators.required, v => (!!v && v.length <= 300) || 'Máximo de 300 caracteres']"
          @change="v => $emit('update:timeoutRespostaSolicitanteMensagem', v)"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col
        md="6"
        cols="12"
      >
        <v-text-field
          v-model="timeoutRespostaSolicitanteMinLocale"
          label="Timeout resposta solicitante em minutos"
          type="number"
          dense
          outlined
          validate-on-blur
          min="1"
          max="10"
          :loading="loading"
          :rules="[validators.select, validators.timeoutValidator]"
          :prepend-inner-icon="icons.mdiClockAlert"
          @change="v => $emit('update:timeoutRespostaSolicitanteMin', v)"
        />
      </v-col>

      <v-col
        md="6"
        cols="12"
      >
        <v-text-field
          v-model="timeoutEncerramentoAtendimentoMinLocale"
          label="Timeout encerramento em minutos"
          type="number"
          dense
          outlined
          validate-on-blur
          min="1"
          max="10"
          :loading="loading"
          :rules="[validators.select, validators.timeoutValidator, validators.timeoutEncerramentoAtendimentoValidator]"
          :prepend-inner-icon="icons.mdiClockAlert"
          @change="v => $emit('update:timeoutEncerramentoAtendimentoMin', v)"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-textarea
          v-model="timeoutEncerramentoAtendimentoMensagemLocale"
          dense
          outlined
          no-resize
          label="Mensagem de encerramento por timeout"
          hint="Máximo de 300 caracteres"
          validate-on-blur
          :loading="loading"
          :rules="[validators.required, v => (!!v && v.length <= 300) || 'Máximo de 300 caracteres']"
          @change="v => $emit('update:timeoutEncerramentoAtendimentoMensagem', v)"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import { mdiClockAlert } from '@mdi/js'
import { required, select } from '@core/utils/validation'

export default {
  emits: ['update:timeoutRespostaSolicitanteMensagem', 'update:timeoutRespostaSolicitanteMin', 'update:timeoutEncerramentoAtendimentoMin', 'update:timeoutEncerramentoAtendimentoMensagem'],

  props: {
    canalData: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },

  setup(props) {
    const timeoutRespostaSolicitanteMensagemLocale = ref(null)
    const timeoutRespostaSolicitanteMinLocale = ref(null)
    const timeoutEncerramentoAtendimentoMinLocale = ref(null)
    const timeoutEncerramentoAtendimentoMensagemLocale = ref(null)

    watch(
      () => props.canalData,
      v => {
        timeoutRespostaSolicitanteMensagemLocale.value = v?.timeoutRespostaSolicitanteMensagem || null
        timeoutRespostaSolicitanteMinLocale.value = v?.timeoutRespostaSolicitanteMin || null
        timeoutEncerramentoAtendimentoMinLocale.value = v?.timeoutEncerramentoAtendimentoMin || null
        timeoutEncerramentoAtendimentoMensagemLocale.value = v?.timeoutEncerramentoAtendimentoMensagem || null
      },
      { immediate: true },
    )

    function timeoutValidator(value) {
      const valueAsInteger = parseInt(value, 10)
      return (Number.isInteger(valueAsInteger) && valueAsInteger > 0 && valueAsInteger <= 10) || 'O timeout deve estar entre 1 e 10 minutos'
    }

    function timeoutEncerramentoAtendimentoValidator(value) {
      return Number(timeoutRespostaSolicitanteMinLocale.value) < Number(value) || 'O tempo de encerramento de atendimento deve ser maior que o tempo de resposta do solicitante.'
    }

    return {
      timeoutRespostaSolicitanteMensagemLocale,
      timeoutRespostaSolicitanteMinLocale,
      timeoutEncerramentoAtendimentoMinLocale,
      timeoutEncerramentoAtendimentoMensagemLocale,
      validators: {
        required,
        select,
        timeoutValidator,
        timeoutEncerramentoAtendimentoValidator,
      },
      icons: { mdiClockAlert },
    }
  },
}
</script>
